import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { usePostApiHeader, usePostApiResponse } from "../../helper/customHook";

const AddOwner = () => {
  // all state
  // user state 
  
  const { user, loading, error } = useSelector((state) => ({
    ...state.user,
  }));
  
  // post api
  const [handlePostApiHeader] = usePostApiHeader();
  const [handlePostResponse] = usePostApiResponse();
  // error state
  const [ownerNameError, setOwnerNameError] = useState("");
  const [submitFormDisable, setSubmitFormDisable] = useState(true);

  // ref
  const ownerNameRef = useRef();
  const ownerAddressRef = useRef();
  const ownerContactNoRef = useRef();
  const activityRef = useRef();

  // navigate
  const navigate = useNavigate();

  const handleOwnerName = () => {
    const ownerName = ownerNameRef.current.value;
    if (ownerName.length) {
      setOwnerNameError("");
      setSubmitFormDisable(false);
    } else {
      setOwnerNameError("This Field can not be Empty");
      setSubmitFormDisable(true);
    }
  };
  const handleAddOwner = async () => {
    const owner_name = ownerNameRef.current.value;
    const address = ownerAddressRef.current.value;
    const contact_no = ownerContactNoRef.current.value;
    const is_active = activityRef.current.value;
    const user_id = user[0]?.data?.user_id
  

    const newOwner = { owner_name, address, contact_no, is_active,user_id };
    fetch(
      "https://kdaback.nescostore.com/api/store-owner",
      await handlePostApiHeader(newOwner)
    )
      .then((res) => res.json())
      .then((data) => handlePostResponse(data, "/allOwner"))
      .catch((error) => {
        console.log("error:", error);
      });
  };
  return (
    <div>
      <h2 className="text-xl text-center my-4 font-semibold">Add Owner</h2>
      <div className="mx-auto lg:w-1/2">
        <div className="form-control my-3">
          <label className="input-group">
            <span className="w-2/6">Owner Name</span>
            <input
              type="text"
              placeholder="ex: Baba Car Service"
              className="input w-4/6 input-bordered"
              ref={ownerNameRef}
              onBlur={handleOwnerName}
            />
          </label>
        </div>
        {ownerNameError && (
          <div className="alert shadow-lg">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
              <span>{ownerNameError}</span>
            </div>
          </div>
        )}
        <div className="form-control my-3">
          <label className="input-group">
            <span className="w-2/6">Owner Address</span>
            <input
              type="text"
              placeholder="ex: Khulna"
              className="input w-4/6 input-bordered"
              ref={ownerAddressRef}
              // onBlur={handleOwnerAddress}
            />
          </label>
        </div>
        <div className="form-control my-3">
          <label className="input-group">
            <span className="w-2/6">Contact Number</span>
            <input
              type="text"
              placeholder="Owner Contact Number"
              className="input w-4/6 input-bordered"
              ref={ownerContactNoRef}
            />
          </label>
        </div>
        <div className="form-control my-3">
          <label className="input-group">
            <span className="w-2/6">Activity</span>
            <select className="select select-bordered w-4/6" ref={activityRef}>
              <option value="1">Active</option>

              <option value="0">Not Active</option>
            </select>
          </label>
        </div>
      </div>
      <div className="w-48 mx-auto">
        <button
          disabled={submitFormDisable}
          className="btn btn-primary my-10 mx-auto lg:w-44"
          onClick={handleAddOwner}
        >
          ADD Owner
        </button>
      </div>
    </div>
  );
};

export default AddOwner;
